// Do not edit this file, it is auto-generated at build time!
import * as BasicContentRowContainerBlock from '../components/blocks/BasicContentRowContainerBlock';
import * as CTABlock from '../components/blocks/CTABlock';
import * as CalloutBlock from '../components/blocks/CalloutBlock';
import * as ContentGridBlock from '../components/blocks/ContentGridBlock';
import * as CustomJsScript from '../components/blocks/CustomJsScript';
import * as CustomPressReleaseListBlock from '../components/blocks/CustomPressReleaseListBlock';
import * as DismissableBannerBlock from '../components/blocks/DismissableBannerBlock';
import * as EditorialCalloutBlock from '../components/blocks/EditorialCalloutBlock';
import * as EditorialModuleContainerBlock from '../components/blocks/EditorialModuleContainerBlock';
import * as EditorialToutWithImageBlock from '../components/blocks/EditorialToutWithImageBlock';
import * as FacultyBioBlock from '../components/blocks/FacultyBioBlock';
import * as FacultyGridBlock from '../components/blocks/FacultyGridBlock';
import * as FeaturedContentBlock from '../components/blocks/FeaturedContentBlock';
import * as FeaturedContentWideBlock from '../components/blocks/FeaturedContentWideBlock';
import * as FeaturedGuests from '../components/blocks/FeaturedGuests';
import * as FindAProgramBlock from '../components/blocks/FindAProgramBlock';
import * as GenericVideoBlock from '../components/blocks/GenericVideoBlock';
import * as IconBlock from '../components/blocks/IconBlock';
import * as IconOrStatsCardBlock from '../components/blocks/IconOrStatsCardBlock';
import * as ImageMediaData from '../components/blocks/ImageMediaData';
import * as LayoutSettings from '../components/blocks/LayoutSettings';
import * as LightboxModal from '../components/blocks/LightboxModal';
import * as LocationsRowBlock from '../components/blocks/LocationsRowBlock';
import * as MissionBlock from '../components/blocks/MissionBlock';
import * as PageIntroBlock from '../components/blocks/PageIntroBlock';
import * as PodcastSeriesBlock from '../components/blocks/PodcastSeriesBlock';
import * as PracticeAreaTickerBlock from '../components/blocks/PracticeAreaTickerBlock';
import * as PressReleaseListBlock from '../components/blocks/PressReleaseListBlock';
import * as ProductSubBlock from '../components/blocks/ProductSubBlock';
import * as ProgressiveOnboardingExperienceContainerBlock from '../components/blocks/ProgressiveOnboardingExperienceContainerBlock';
import * as PublicationTableOfContent from '../components/blocks/PublicationTableOfContent';
import * as QuoteCarousel from '../components/blocks/QuoteCarousel';
import * as RequestAQuoteModalBlock from '../components/blocks/RequestAQuoteModalBlock';
import * as RichTextBlock from '../components/blocks/RichTextBlock';
import * as RssContentBlock from '../components/blocks/RssContentBlock';
import * as SearchFindAProgramButtonsBlock from '../components/blocks/SearchFindAProgramButtonsBlock';
import * as SearchResultBlock from '../components/blocks/SearchResultBlock';
import * as StandardWhiteHeaderBlock from '../components/blocks/StandardWhiteHeaderBlock';
import * as StartTrialModalBlock from '../components/blocks/StartTrialModalBlock';
import * as SubnavBlock from '../components/blocks/SubnavBlock';
import * as SubscriptionBlock from '../components/blocks/SubscriptionBlock';
import * as WalkthroughExperienceModalBlock from '../components/blocks/WalkthroughExperienceModalBlock';
import * as AccordionContainerBlock from '../components/blocks/Accordion/AccordionContainerBlock';
import * as AccordionItemBlock from '../components/blocks/Accordion/AccordionItemBlock';
import * as AccordionLinkBlock from '../components/blocks/Accordion/AccordionLinkBlock';
import * as AccordionLinkItem from '../components/blocks/Accordion/AccordionLinkItem';
import * as IconLinkBlock from '../components/blocks/Accordion/IconLinkBlock';
import * as FeaturedCardLayout from '../components/blocks/Collections/FeaturedCardLayout';
import * as FeaturedCollectionsBlock from '../components/blocks/Collections/FeaturedCollectionsBlock';
import * as BannerMessageBlock from '../components/blocks/CreditInfo/BannerMessageBlock';
import * as BrowseByCreditBlock from '../components/blocks/CreditInfo/BrowseByCreditBlock';
import * as UserJurisdictionsBlock from '../components/blocks/CreditInfo/UserJurisdictionsBlock';
import * as CreditInfoContext from '../components/blocks/CreditInfo/context/CreditInfoContext';
import * as useCreditInfoHook from '../components/blocks/CreditInfo/hooks/useCreditInfoHook';
import * as CreditClassContent from '../components/blocks/CreditInfo/snippets/CreditClassContent';
import * as CreditInfoAccordionItem from '../components/blocks/CreditInfo/snippets/CreditInfoAccordionItem';
import * as CreditInfoAccordionSection from '../components/blocks/CreditInfo/snippets/CreditInfoAccordionSection';
import * as CreditInfoHeader from '../components/blocks/CreditInfo/snippets/CreditInfoHeader';
import * as CreditInfoOverview from '../components/blocks/CreditInfo/snippets/CreditInfoOverview';
import * as JurisdictionHeaderRequirementMessage from '../components/blocks/CreditInfo/snippets/JurisdictionHeaderRequirementMessage';
import * as LoadingShimmers from '../components/blocks/CreditInfo/snippets/LoadingShimmers';
import * as creditInfoConstants from '../components/blocks/CreditInfo/util/creditInfoConstants';
import * as creditInfoHelpers from '../components/blocks/CreditInfo/util/creditInfoHelpers';
import * as CreditOverviewBlock from '../components/blocks/CreditTracker/CreditOverviewBlock';
import * as CreditTrackerContext from '../components/blocks/CreditTracker/CreditTrackerContext';
import * as MiniTrackerBlock from '../components/blocks/CreditTracker/MiniTrackerBlock';
import * as MemsuiteHeaderBlock from '../components/blocks/CreditTrackerAdmin/MemsuiteHeaderBlock';
import * as AddLicenseBlock from '../components/blocks/EmptyStateBlock/AddLicenseBlock';
import * as EmptyStateBlock from '../components/blocks/EmptyStateBlock/EmptyStateBlock';
import * as FacultyMemberBlock from '../components/blocks/FacultyRowContainer/FacultyMemberBlock';
import * as FacultyRowContainerBlock from '../components/blocks/FacultyRowContainer/FacultyRowContainerBlock';
import * as AddLicenseStep from '../components/blocks/FinishProfileBlock/AddLicenseStep';
import * as FinishProfileBlock from '../components/blocks/FinishProfileBlock/FinishProfileBlock';
import * as MultiStepModalBlock from '../components/blocks/FinishProfileBlock/MultiStepModalBlock';
import * as PracticeAreaStep from '../components/blocks/FinishProfileBlock/PracticeAreaStep';
import * as RolesStep from '../components/blocks/FinishProfileBlock/RolesStep';
import * as FooterBlock from '../components/blocks/Footer/FooterBlock';
import * as FooterLinkListBlock from '../components/blocks/Footer/FooterLinkListBlock';
import * as FooterNav from '../components/blocks/Footer/FooterNav';
import * as GlobalBannerBlock from '../components/blocks/GlobalBanner/GlobalBannerBlock';
import * as GlobalBannerHeader from '../components/blocks/GlobalBanner/GlobalBannerHeader';
import * as GlobalBannerPanel from '../components/blocks/GlobalBanner/GlobalBannerPanel';
import * as HeaderBlock from '../components/blocks/Header/HeaderBlock';
import * as NavigationItemBlock from '../components/blocks/Header/NavigationItemBlock';
import * as PanelAccountNavMobile from '../components/blocks/Header/PanelAccountNavMobile';
import * as PanelAccountNavTablet from '../components/blocks/Header/PanelAccountNavTablet';
import * as PanelNavMobile from '../components/blocks/Header/PanelNavMobile';
import * as PanelNavTablet from '../components/blocks/Header/PanelNavTablet';
import * as SubnavigationItemBlock from '../components/blocks/Header/SubnavigationItemBlock';
import * as EditorialSlideBlock from '../components/blocks/HomePageCarousel/EditorialSlideBlock';
import * as FullSizeSlideBlock from '../components/blocks/HomePageCarousel/FullSizeSlideBlock';
import * as HomePageCarousel from '../components/blocks/HomePageCarousel/HomePageCarousel';
import * as LiveNowSlideBlock from '../components/blocks/HomePageCarousel/LiveNowSlideBlock';
import * as LiveSliceBlock from '../components/blocks/HomePageCarousel/LiveSliceBlock';
import * as OnDemandSliceBlock from '../components/blocks/HomePageCarousel/OnDemandSliceBlock';
import * as PodcastProgramSlide from '../components/blocks/HomePageCarousel/PodcastProgramSlide';
import * as TwoUpSlideBlock from '../components/blocks/HomePageCarousel/TwoUpSlideBlock';
import * as InteractiveEditorialBlock from '../components/blocks/ILC/InteractiveEditorialBlock';
import * as InteractiveEditorialBlockItem from '../components/blocks/ILC/InteractiveEditorialBlockItem';
import * as LargeCarouselContainerBlock from '../components/blocks/LargeCarousel/LargeCarouselContainerBlock';
import * as LargeCarouselSlideFifty from '../components/blocks/LargeCarousel/LargeCarouselSlideFifty';
import * as LargeCarouselSlideFull from '../components/blocks/LargeCarousel/LargeCarouselSlideFull';
import * as LargeCarouselSlideGallery from '../components/blocks/LargeCarousel/LargeCarouselSlideGallery';
import * as constants from '../components/blocks/LargeCarousel/utils/constants';
import * as helpers from '../components/blocks/LargeCarousel/utils/helpers';
import * as FacultyLinkBlock from '../components/blocks/LinkGridBlock/FacultyLinkBlock';
import * as JavascriptLinkBlock from '../components/blocks/LinkGridBlock/JavascriptLinkBlock';
import * as LinkBlock from '../components/blocks/LinkGridBlock/LinkBlock';
import * as LinkGridBlock from '../components/blocks/LinkGridBlock/LinkGridBlock';
import * as LinkGridBlockCollapsible from '../components/blocks/LinkGridBlock/LinkGridBlockCollapsible';
import * as LinkGridBlockContent from '../components/blocks/LinkGridBlock/LinkGridBlockContent';
import * as LinkGridBlockNonCollapsible from '../components/blocks/LinkGridBlock/LinkGridBlockNonCollapsible';
import * as TextLinkBlock from '../components/blocks/LinkGridBlock/TextLinkBlock';
import * as BrandHeaderBlock from '../components/blocks/Masthead/BrandHeaderBlock';
import * as ImpactHeaderBlock from '../components/blocks/Masthead/ImpactHeaderBlock';
import * as SignatureHeaderBlock from '../components/blocks/Masthead/SignatureHeaderBlock';
import * as StandardBlackHeaderBlock from '../components/blocks/Masthead/StandardBlackHeaderBlock';
import * as StandardGrayHeaderBlock from '../components/blocks/Masthead/StandardGrayHeaderBlock';
import * as IPDPContentLayoutBlock from '../components/blocks/PDP/IPDPContentLayoutBlock';
import * as IPDPOverviewLayoutBlock from '../components/blocks/PDP/IPDPOverviewLayoutBlock';
import * as IPDPProgramCreditLayoutBlock from '../components/blocks/PDP/IPDPProgramCreditLayoutBlock';
import * as IPDPProgramFacultyLayoutBlock from '../components/blocks/PDP/IPDPProgramFacultyLayoutBlock';
import * as IPDPProgramLocationDetailsLayoutBlock from '../components/blocks/PDP/IPDPProgramLocationDetailsLayoutBlock';
import * as IPDPProgramScheduleLayoutBlock from '../components/blocks/PDP/IPDPProgramScheduleLayoutBlock';
import * as IPDPProgramSegmentsLayoutBlock from '../components/blocks/PDP/IPDPProgramSegmentsLayoutBlock';
import * as IPDPTestimonialsLayoutBlock from '../components/blocks/PDP/IPDPTestimonialsLayoutBlock';
import * as IPDPTopicsAndIndustriesLayoutBlock from '../components/blocks/PDP/IPDPTopicsAndIndustriesLayoutBlock';
import * as TimedAgendaBlock from '../components/blocks/PDP/TimedAgendaBlock';
import * as IPDPAdditionalInfo1LayoutBlock from '../components/blocks/PDP/overview/IPDPAdditionalInfo1LayoutBlock';
import * as IPDPAdditionalInfo2LayoutBlock from '../components/blocks/PDP/overview/IPDPAdditionalInfo2LayoutBlock';
import * as IPDPAdditionalInfo3LayoutBlock from '../components/blocks/PDP/overview/IPDPAdditionalInfo3LayoutBlock';
import * as IPDPProgramAnnouncementsLayoutBlock from '../components/blocks/PDP/overview/IPDPProgramAnnouncementsLayoutBlock';
import * as IPDPSpecialFeaturesLayoutBlock from '../components/blocks/PDP/overview/IPDPSpecialFeaturesLayoutBlock';
import * as IPDPWhatYouWillLearnLayoutBlock from '../components/blocks/PDP/overview/IPDPWhatYouWillLearnLayoutBlock';
import * as IPDPWhoShouldAttendLayoutLayoutBlock from '../components/blocks/PDP/overview/IPDPWhoShouldAttendLayoutLayoutBlock';
import * as IPDPWhyYouShouldAttendLayoutBlock from '../components/blocks/PDP/overview/IPDPWhyYouShouldAttendLayoutBlock';
import * as PodcastListingBlock from '../components/blocks/PodcastListingBlock/PodcastListingBlock';
import * as PodcastListingContent from '../components/blocks/PodcastListingBlock/PodcastListingContent';
import * as PodcastListingSingle from '../components/blocks/PodcastListingBlock/PodcastListingSingle';
import * as PracticeAreaMasthead from '../components/blocks/PracticeArea/PracticeAreaMasthead';
import * as SecondaryTaxonomyBlock from '../components/blocks/PracticeArea/SecondaryTaxonomyBlock';
import * as SecondaryTaxonomyBlockShimmer from '../components/blocks/PracticeArea/SecondaryTaxonomyBlockShimmer';
import * as OrderHistoryBlock from '../components/blocks/Profile/OrderHistoryBlock';
import * as PaymentsCardsBlock from '../components/blocks/Profile/PaymentsCardsBlock';
import * as PersonalInfoAboutBlock from '../components/blocks/Profile/PersonalInfoAboutBlock';
import * as PersonalInfoAddressesBlock from '../components/blocks/Profile/PersonalInfoAddressesBlock';
import * as PersonalInfoContactInfoBlock from '../components/blocks/Profile/PersonalInfoContactInfoBlock';
import * as PersonalInfoFacultyBlock from '../components/blocks/Profile/PersonalInfoFacultyBlock';
import * as PersonalInfoIndustriesBlock from '../components/blocks/Profile/PersonalInfoIndustriesBlock';
import * as PersonalInfoLoginDetailsBlock from '../components/blocks/Profile/PersonalInfoLoginDetailsBlock';
import * as PersonalInfoPracticeAreasBlock from '../components/blocks/Profile/PersonalInfoPracticeAreasBlock';
import * as PreferencesCommunicationBlock from '../components/blocks/Profile/PreferencesCommunicationBlock';
import * as POECTabsContainerBlock from '../components/blocks/Tabs/POECTabsContainerBlock';
import * as TabBlock from '../components/blocks/Tabs/TabBlock';
import * as TabsContainerBlock from '../components/blocks/Tabs/TabsContainerBlock';
import * as TaxonomyItem from '../components/blocks/Tabs/TaxonomyItem';
import * as TaxonomyTabContainerBlock from '../components/blocks/Tabs/TaxonomyTabContainerBlock';
import * as TaxonomyTabItemBlock from '../components/blocks/Tabs/TaxonomyTabItemBlock';
import * as CTAIconSubBlock from '../components/blocks/Tiles/CTAIconSubBlock';
import * as ImageSubBlock from '../components/blocks/Tiles/ImageSubBlock';
import * as LongTileSubBlock from '../components/blocks/Tiles/LongTileSubBlock';
import * as MembersRowCollapsible from '../components/blocks/Tiles/MembersRowCollapsible';
import * as MembersRowNonCollapsible from '../components/blocks/Tiles/MembersRowNonCollapsible';
import * as TileBlock from '../components/blocks/Tiles/TileBlock';
import * as TileCarouselBlock from '../components/blocks/Tiles/TileCarouselBlock';
import * as TimelineCarouselContainerBlock from '../components/blocks/TimelineCarouselBlock/TimelineCarouselContainerBlock';
import * as TimelineSlideBlock from '../components/blocks/TimelineCarouselBlock/TimelineSlideBlock';
import * as TooltipBlock from '../components/blocks/Tooltip/TooltipBlock';
import * as GenericContentCardBlock from '../components/blocks/TwoUpBlock/GenericContentCardBlock';
import * as TwoUpBlock from '../components/blocks/TwoUpBlock/TwoUpBlock';

const components = new Map();

components.set('BasicContentRowContainerBlock', BasicContentRowContainerBlock);
components.set('CTABlock', CTABlock);
components.set('CalloutBlock', CalloutBlock);
components.set('ContentGridBlock', ContentGridBlock);
components.set('CustomJsScript', CustomJsScript);
components.set('CustomPressReleaseListBlock', CustomPressReleaseListBlock);
components.set('DismissableBannerBlock', DismissableBannerBlock);
components.set('EditorialCalloutBlock', EditorialCalloutBlock);
components.set('EditorialModuleContainerBlock', EditorialModuleContainerBlock);
components.set('EditorialToutWithImageBlock', EditorialToutWithImageBlock);
components.set('FacultyBioBlock', FacultyBioBlock);
components.set('FacultyGridBlock', FacultyGridBlock);
components.set('FeaturedContentBlock', FeaturedContentBlock);
components.set('FeaturedContentWideBlock', FeaturedContentWideBlock);
components.set('FeaturedGuests', FeaturedGuests);
components.set('FindAProgramBlock', FindAProgramBlock);
components.set('GenericVideoBlock', GenericVideoBlock);
components.set('IconBlock', IconBlock);
components.set('IconOrStatsCardBlock', IconOrStatsCardBlock);
components.set('ImageMediaData', ImageMediaData);
components.set('LayoutSettings', LayoutSettings);
components.set('LightboxModal', LightboxModal);
components.set('LocationsRowBlock', LocationsRowBlock);
components.set('MissionBlock', MissionBlock);
components.set('PageIntroBlock', PageIntroBlock);
components.set('PodcastSeriesBlock', PodcastSeriesBlock);
components.set('PracticeAreaTickerBlock', PracticeAreaTickerBlock);
components.set('PressReleaseListBlock', PressReleaseListBlock);
components.set('ProductSubBlock', ProductSubBlock);
components.set(
  'ProgressiveOnboardingExperienceContainerBlock',
  ProgressiveOnboardingExperienceContainerBlock
);
components.set('PublicationTableOfContent', PublicationTableOfContent);
components.set('QuoteCarousel', QuoteCarousel);
components.set('RequestAQuoteModalBlock', RequestAQuoteModalBlock);
components.set('RichTextBlock', RichTextBlock);
components.set('RssContentBlock', RssContentBlock);
components.set('SearchFindAProgramButtonsBlock', SearchFindAProgramButtonsBlock);
components.set('SearchResultBlock', SearchResultBlock);
components.set('StandardWhiteHeaderBlock', StandardWhiteHeaderBlock);
components.set('StartTrialModalBlock', StartTrialModalBlock);
components.set('SubnavBlock', SubnavBlock);
components.set('SubscriptionBlock', SubscriptionBlock);
components.set('WalkthroughExperienceModalBlock', WalkthroughExperienceModalBlock);
components.set('AccordionContainerBlock', AccordionContainerBlock);
components.set('AccordionItemBlock', AccordionItemBlock);
components.set('AccordionLinkBlock', AccordionLinkBlock);
components.set('AccordionLinkItem', AccordionLinkItem);
components.set('IconLinkBlock', IconLinkBlock);
components.set('FeaturedCardLayout', FeaturedCardLayout);
components.set('FeaturedCollectionsBlock', FeaturedCollectionsBlock);
components.set('BannerMessageBlock', BannerMessageBlock);
components.set('BrowseByCreditBlock', BrowseByCreditBlock);
components.set('UserJurisdictionsBlock', UserJurisdictionsBlock);
components.set('CreditInfoContext', CreditInfoContext);
components.set('useCreditInfoHook', useCreditInfoHook);
components.set('CreditClassContent', CreditClassContent);
components.set('CreditInfoAccordionItem', CreditInfoAccordionItem);
components.set('CreditInfoAccordionSection', CreditInfoAccordionSection);
components.set('CreditInfoHeader', CreditInfoHeader);
components.set('CreditInfoOverview', CreditInfoOverview);
components.set('JurisdictionHeaderRequirementMessage', JurisdictionHeaderRequirementMessage);
components.set('LoadingShimmers', LoadingShimmers);
components.set('creditInfoConstants', creditInfoConstants);
components.set('creditInfoHelpers', creditInfoHelpers);
components.set('CreditOverviewBlock', CreditOverviewBlock);
components.set('CreditTrackerContext', CreditTrackerContext);
components.set('MiniTrackerBlock', MiniTrackerBlock);
components.set('MemsuiteHeaderBlock', MemsuiteHeaderBlock);
components.set('AddLicenseBlock', AddLicenseBlock);
components.set('EmptyStateBlock', EmptyStateBlock);
components.set('FacultyMemberBlock', FacultyMemberBlock);
components.set('FacultyRowContainerBlock', FacultyRowContainerBlock);
components.set('AddLicenseStep', AddLicenseStep);
components.set('FinishProfileBlock', FinishProfileBlock);
components.set('MultiStepModalBlock', MultiStepModalBlock);
components.set('PracticeAreaStep', PracticeAreaStep);
components.set('RolesStep', RolesStep);
components.set('FooterBlock', FooterBlock);
components.set('FooterLinkListBlock', FooterLinkListBlock);
components.set('FooterNav', FooterNav);
components.set('GlobalBannerBlock', GlobalBannerBlock);
components.set('GlobalBannerHeader', GlobalBannerHeader);
components.set('GlobalBannerPanel', GlobalBannerPanel);
components.set('HeaderBlock', HeaderBlock);
components.set('NavigationItemBlock', NavigationItemBlock);
components.set('PanelAccountNavMobile', PanelAccountNavMobile);
components.set('PanelAccountNavTablet', PanelAccountNavTablet);
components.set('PanelNavMobile', PanelNavMobile);
components.set('PanelNavTablet', PanelNavTablet);
components.set('SubnavigationItemBlock', SubnavigationItemBlock);
components.set('EditorialSlideBlock', EditorialSlideBlock);
components.set('FullSizeSlideBlock', FullSizeSlideBlock);
components.set('HomePageCarousel', HomePageCarousel);
components.set('LiveNowSlideBlock', LiveNowSlideBlock);
components.set('LiveSliceBlock', LiveSliceBlock);
components.set('OnDemandSliceBlock', OnDemandSliceBlock);
components.set('PodcastProgramSlide', PodcastProgramSlide);
components.set('TwoUpSlideBlock', TwoUpSlideBlock);
components.set('InteractiveEditorialBlock', InteractiveEditorialBlock);
components.set('InteractiveEditorialBlockItem', InteractiveEditorialBlockItem);
components.set('LargeCarouselContainerBlock', LargeCarouselContainerBlock);
components.set('LargeCarouselSlideFifty', LargeCarouselSlideFifty);
components.set('LargeCarouselSlideFull', LargeCarouselSlideFull);
components.set('LargeCarouselSlideGallery', LargeCarouselSlideGallery);
components.set('constants', constants);
components.set('helpers', helpers);
components.set('FacultyLinkBlock', FacultyLinkBlock);
components.set('JavascriptLinkBlock', JavascriptLinkBlock);
components.set('LinkBlock', LinkBlock);
components.set('LinkGridBlock', LinkGridBlock);
components.set('LinkGridBlockCollapsible', LinkGridBlockCollapsible);
components.set('LinkGridBlockContent', LinkGridBlockContent);
components.set('LinkGridBlockNonCollapsible', LinkGridBlockNonCollapsible);
components.set('TextLinkBlock', TextLinkBlock);
components.set('BrandHeaderBlock', BrandHeaderBlock);
components.set('ImpactHeaderBlock', ImpactHeaderBlock);
components.set('SignatureHeaderBlock', SignatureHeaderBlock);
components.set('StandardBlackHeaderBlock', StandardBlackHeaderBlock);
components.set('StandardGrayHeaderBlock', StandardGrayHeaderBlock);
components.set('IPDPContentLayoutBlock', IPDPContentLayoutBlock);
components.set('IPDPOverviewLayoutBlock', IPDPOverviewLayoutBlock);
components.set('IPDPProgramCreditLayoutBlock', IPDPProgramCreditLayoutBlock);
components.set('IPDPProgramFacultyLayoutBlock', IPDPProgramFacultyLayoutBlock);
components.set('IPDPProgramLocationDetailsLayoutBlock', IPDPProgramLocationDetailsLayoutBlock);
components.set('IPDPProgramScheduleLayoutBlock', IPDPProgramScheduleLayoutBlock);
components.set('IPDPProgramSegmentsLayoutBlock', IPDPProgramSegmentsLayoutBlock);
components.set('IPDPTestimonialsLayoutBlock', IPDPTestimonialsLayoutBlock);
components.set('IPDPTopicsAndIndustriesLayoutBlock', IPDPTopicsAndIndustriesLayoutBlock);
components.set('TimedAgendaBlock', TimedAgendaBlock);
components.set('IPDPAdditionalInfo1LayoutBlock', IPDPAdditionalInfo1LayoutBlock);
components.set('IPDPAdditionalInfo2LayoutBlock', IPDPAdditionalInfo2LayoutBlock);
components.set('IPDPAdditionalInfo3LayoutBlock', IPDPAdditionalInfo3LayoutBlock);
components.set('IPDPProgramAnnouncementsLayoutBlock', IPDPProgramAnnouncementsLayoutBlock);
components.set('IPDPSpecialFeaturesLayoutBlock', IPDPSpecialFeaturesLayoutBlock);
components.set('IPDPWhatYouWillLearnLayoutBlock', IPDPWhatYouWillLearnLayoutBlock);
components.set('IPDPWhoShouldAttendLayoutLayoutBlock', IPDPWhoShouldAttendLayoutLayoutBlock);
components.set('IPDPWhyYouShouldAttendLayoutBlock', IPDPWhyYouShouldAttendLayoutBlock);
components.set('PodcastListingBlock', PodcastListingBlock);
components.set('PodcastListingContent', PodcastListingContent);
components.set('PodcastListingSingle', PodcastListingSingle);
components.set('PracticeAreaMasthead', PracticeAreaMasthead);
components.set('SecondaryTaxonomyBlock', SecondaryTaxonomyBlock);
components.set('SecondaryTaxonomyBlockShimmer', SecondaryTaxonomyBlockShimmer);
components.set('OrderHistoryBlock', OrderHistoryBlock);
components.set('PaymentsCardsBlock', PaymentsCardsBlock);
components.set('PersonalInfoAboutBlock', PersonalInfoAboutBlock);
components.set('PersonalInfoAddressesBlock', PersonalInfoAddressesBlock);
components.set('PersonalInfoContactInfoBlock', PersonalInfoContactInfoBlock);
components.set('PersonalInfoFacultyBlock', PersonalInfoFacultyBlock);
components.set('PersonalInfoIndustriesBlock', PersonalInfoIndustriesBlock);
components.set('PersonalInfoLoginDetailsBlock', PersonalInfoLoginDetailsBlock);
components.set('PersonalInfoPracticeAreasBlock', PersonalInfoPracticeAreasBlock);
components.set('PreferencesCommunicationBlock', PreferencesCommunicationBlock);
components.set('POECTabsContainerBlock', POECTabsContainerBlock);
components.set('TabBlock', TabBlock);
components.set('TabsContainerBlock', TabsContainerBlock);
components.set('TaxonomyItem', TaxonomyItem);
components.set('TaxonomyTabContainerBlock', TaxonomyTabContainerBlock);
components.set('TaxonomyTabItemBlock', TaxonomyTabItemBlock);
components.set('CTAIconSubBlock', CTAIconSubBlock);
components.set('ImageSubBlock', ImageSubBlock);
components.set('LongTileSubBlock', LongTileSubBlock);
components.set('MembersRowCollapsible', MembersRowCollapsible);
components.set('MembersRowNonCollapsible', MembersRowNonCollapsible);
components.set('TileBlock', TileBlock);
components.set('TileCarouselBlock', TileCarouselBlock);
components.set('TimelineCarouselContainerBlock', TimelineCarouselContainerBlock);
components.set('TimelineSlideBlock', TimelineSlideBlock);
components.set('TooltipBlock', TooltipBlock);
components.set('GenericContentCardBlock', GenericContentCardBlock);
components.set('TwoUpBlock', TwoUpBlock);

export function componentFactory(componentName: string) {
  const component = components.get(componentName);

  return component?.Default || component?.default || component;
}
